import { RecordItemType } from '@/pages/intelligence/components/SearchRecent/type';
import { getCountryFlag } from '@/pages/home/_config/countries';

/**
 * @description 深度比较数据值是否相同
 * @param a 数据a
 * @param b 数据b
 * @returns 比较结果
 */
export function deepCompare(a: any, b: any) {
  // 基本数据类型判断
  if (a === null || typeof a !== 'object' || b === null || typeof b !== 'object') {
    return a === b;
  }
  // a,b 类型不一致
  if (Object.prototype.toString.call(a) !== Object.prototype.toString.call(b)) {
    return false;
  }

  // 判断是否是数组
  const isArray = Array.isArray(a);
  const propsALength =  isArray ? a.length : Object.keys(Object.getOwnPropertyDescriptors(a)).length;
  const propsBLength = isArray ? b.length : Object.keys(Object.getOwnPropertyDescriptors(b)).length;
  // 判断a,b属性个数是否一致
  if (propsALength !== propsBLength) {
    return false;
  }

  // 遍历数组每一项是否相同
  if (isArray) {
    return a.every((item, index) => deepCompare(item, b[index]));
  }

  // 遍历对象属性是否相同
  return Object.keys(a).every(key => deepCompare(a[key], b[key]));
}

export const transTableDataForSearch = (res: any) => {
  const resultList = res?.data?.rank_au_list;
  if (!Array.isArray(resultList) || !resultList?.length) {
    return [];
  }
  const tranksList: RecordItemType[] = resultList.map((item) => {
    return {
      id: item?.app_id,
      imgSrc: item?.cover,
      lineOneStr: item?.name,
      lineTwoImg: getCountryFlag(item?.markets),
      lineTwoImgName: item?.markets,
      lineTwoStr: item?.publisher,
    };
  });
  return tranksList;
};
